const i18n = {
	forms: {
		es_ar: {
			global: 'Hubo un error. Inténtalo de nuevo',
			required: 'Por favor completa este campo',
			fullname: 'Tu nombre no debe exceder los 40 caracteres',
			firstname: 'Tu nombre no debe exceder los 40 caracteres',
			lastname: 'Tu apellido no debe exceder los 40 caracteres',
			email: 'Por favor introduzca un correo electrónico válido',
			textarea: 'Tu mensaje no debe exceder los 1600 caracteres',
			company: 'Tu empresa no debe superar los 60 caracteres',
			role: 'Tu rol no debe exceder los 60 caracteres',
			phone: 'Por favor introduzca un teléfono válido',
			url: 'Por favor introduzca una URL válida',
			loading: 'Cargando los datos',
			success: 'Gracias'
		},
		en_us: {
			global: 'An error was encountered. Please try again',
			required: 'Please fill out this field',
			fullname: 'Your name must not exceed 40 characters',
			firstname: 'Your first name must not exceed 40 characters',
			lastname: 'Your last name must not exceed 40 characters',
			email: 'Please enter a valid e-mail',
			textarea: 'Your message must not exceed 1600 characters',
			company: 'Your company must not exceed 60 characters',
			role: 'Your role must not exceed 60 characters',
			phone: 'Please enter a valid phone',
			url: 'Please enter a valid URL',
			loading: 'Please Wait',
			success: 'Thank You'
		}
	}
};

export default i18n;